import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, vShow as _vShow, createElementVNode as _createElementVNode, withDirectives as _withDirectives, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-fc28582e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "OrderAdjustment_Pagenation" }
const _hoisted_2 = { class: "paging_container" }
const _hoisted_3 = { class: "OrderAdjustment_BtnBlock" }
const _hoisted_4 = ["disabled"]
const _hoisted_5 = {
  key: 1,
  class: "loading"
}
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block"} }, "ダウンロード", -1))
const _hoisted_7 = { class: "OrderAdjustment_Table" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("th", { class: "OrderAdjustment_Table_Medium OrderAdjustment_Table_Sticky_TH1" }, " 操作 ", -1))
const _hoisted_9 = { class: "OrderAdjustment_Table_Syosi OrderAdjustment_Table_Sticky_TH2 th_sort" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_14 = { key: 0 }
const _hoisted_15 = { class: "OrderAdjustment_Table_Sticky_TD1" }
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "OrderAdjustment_Table_SyosiInfo OrderAdjustment_Table_Sticky_TD2 Text_Left" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_19 = { class: "OrderAdjustment_Table_SyosiInfo OrderAdjustment_Table_Sticky_TD3 Text_Left" }
const _hoisted_20 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_22 = {
  key: 0,
  class: "ResultMessageNull"
}

import { ref, watchEffect } from "vue";
import { useRouter } from "vue-router";
import { useStore } from "vuex";
import axios from "axios";
import Paginate from "vuejs-paginate-next";
import PankuzuHeader from "../components/PankuzuHeader.vue";
import OrderHeader from "../components/OrderHeader.vue";
import { Notyf } from "notyf";


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderAdjustment',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["showGlobalHeader", "toggleGlobalHeader"],
  setup(__props) {

const notyf = new Notyf();
const props = __props;
// // Emitの定義


// ストア関連
const store = useStore();
// ストアの初期化→routerで実装

const $router = useRouter();
const toAdjustmentDetail = (janCd: string): void => {
  $router.push({
    name: "OrderAdjustmentDetail",
    query: { isLogMode: 0, janCd: janCd },
  });
};

//ぱんくずヘッダー
const currentPathList = [{ name: "受注入力" }, { name: "調整" }];
//検索エリア表示
let searchAreaToggle: boolean = true;

//簡易検索
let isActive_KaniFlg = ref(false);
const changeKaniFlg = (KaniFlg: boolean): void => {
  isActive_KaniFlg.value = KaniFlg;
};

//詳細検索
let isActive_SyosaiFlg = ref(true);
const changeSyosaiFlg = (SyosaiFlg: boolean): void => {
  isActive_SyosaiFlg.value = SyosaiFlg;
};

//テーブルの高さ調整用
let isOpentoggleArea = ref<boolean>(true);
const changeToggleArea = (toggleAreaFlg: boolean): void => {
  isOpentoggleArea.value = toggleAreaFlg;
};
const tableHeight = () => {
  if (isOpentoggleArea.value) {
    //詳細ヘッダが空いているときのみテーブルを短くする
    return "OrderAdjustment_TableContainer_Short";
  } else {
    //その他
    return "OrderAdjustment_TableContainer_Long";
  }
};

//全ソート関連
const initialSortInfo = store.getters["search/getOrderAdjustmentSortInfo"];
let sortInfo = ref({
  sortItem: initialSortInfo.sortItem,
  isKoujun: initialSortInfo.isKoujun,
});
let isSorting = ref(initialSortInfo.isSorting);
watchEffect(() => {
  store.commit("search/setOrderAdjustmentSortInfo", {
    sortItem: sortInfo.value.sortItem,
    isKoujun: sortInfo.value.isKoujun,
    isSorting: isSorting.value,
  });
});

const sortTable = async (sortItem: string) => {
  isSorting.value = true;
  if (sortInfo.value.sortItem === sortItem) {
    sortInfo.value.isKoujun = !sortInfo.value.isKoujun;
  } else {
    sortInfo.value.isKoujun = false;
    // 別のソートに切り替えた時ページネーションを1にする
    currentPage.value = 1;
    store.commit("search/setPageNumber", currentPage.value);
  }
  sortInfo.value.sortItem = sortItem;

  onSearch();
};

const showSortSymbol = (sortItem: string) => {
  if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    sortInfo.value.isKoujun
  ) {
    return "▼";
  } else if (
    isSorting.value &&
    sortInfo.value.sortItem === sortItem &&
    !sortInfo.value.isKoujun
  ) {
    return "▲";
  } else {
    return "";
  }
};
// ページネーション関連処理-----------------------------------------
// 取得データ合計
let numberOfTotalData = ref<number>(0);
// 1ページあたりの表示データ数(一旦固定)
let dataPerPage = 100;
//表示中のページ範囲
let firstCount = ref<number>(0);
let finalCount = ref<number>(0);
// 総ページ数
const numberOfTotalPage = ref<number>(0);
// 現在のページ数
const currentPage = ref<number>(store.getters["search/getPageNumber"]);
const getTotalPage = () => {
  numberOfTotalPage.value = Math.ceil(numberOfTotalData.value / dataPerPage);
};

//調整データ取得
// APIから返ってくる値が確定したらanyに型をつける
const search_result = ref<any[]>([]);
const choseiInputExecutableFlg = ref<boolean>(false); //調整データ取り込み実行ボタン表示用
// const shinagireKaijoExecutableFlg = ref<boolean>(false);//品切れ解除実行ボタン表示用
const onSearch = async () => {
  search_result.value.splice(0);
  const searchDetailState = store.getters["search/getSearchState"];
  const searchSimpleState = store.getters["search/getEncodeSearchSimpleState"];
  try {
    let res;
    if (isSorting.value === true) {
      res = await axios.get(
        `${store.getters["getBaseUrl"]}/chosei?freeword=${searchSimpleState}&fromDate=${searchDetailState.fromDate}&toDate=${searchDetailState.toDate}&syosiCd=${searchDetailState.syosiCd}&syubetu=${searchDetailState.syubetu}&category=${searchDetailState.category}&zaikoStatus=${searchDetailState.zaikoStatus}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}
      &order=${sortInfo.value.sortItem}&sort=${sortInfo.value.isKoujun}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );
    } else {
      res = await axios.get(
        `${store.getters["getBaseUrl"]}/chosei?freeword=${searchSimpleState}&fromDate=${searchDetailState.fromDate}&toDate=${searchDetailState.toDate}&syosiCd=${searchDetailState.syosiCd}&syubetu=${searchDetailState.syubetu}&category=${searchDetailState.category}&zaikoStatus=${searchDetailState.zaikoStatus}&page=${currentPage.value}&numberOfDisplay=${dataPerPage}`,
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
          },
        },
      );
    }
    res.data.choseiDataList.forEach((chosei: any) => {
      search_result.value.push({ ...chosei });
    });
    // console.log(search_result.value);
    numberOfTotalData.value = res.data.size;
    firstCount.value = res.data.firstCount;
    finalCount.value = res.data.finalCount;
    choseiInputExecutableFlg.value = res.data.choseiInputExecutableFlg;
    // console.log("choseiInputExecutableFlg", choseiInputExecutableFlg.value);
    getTotalPage();
  } catch (error) {
    console.log(error);
  }
};

const created = async () => {
  onSearch();
};
created();

const onClickPage = (newPage: number) => {
  currentPage.value = newPage;
  store.commit("search/setPageNumber", currentPage.value);
  onSearch();
};

// 検索ボタンがクリックされたらソート設定を初期値に戻す
const onClickSearch = () => {
  store.commit("search/resetPage");
  currentPage.value = 1;
  // ソートをデフォルトの受注数の降順にする
  isSorting.value = true;
  sortInfo.value.isKoujun = true;
  sortInfo.value.sortItem = "juchuSuu";
  onSearch();
};

// ダウンロード関連--------------------------------------------------
let isDownLoading = ref(false);
const downloadChoseiData = async () => {
  isDownLoading.value = false;
  const simpleState = store.getters["search/getEncodeSearchSimpleState"];
  const detailState = store.getters["search/getSearchState"];
  try {
    isDownLoading.value = true;
    const searchParams = `fromDate=${detailState.fromDate}&toDate=${detailState.toDate}&syubetu=${detailState.syubetu}&category=${detailState.category}&zaikoStatus=${detailState.zaikoStatus}&freeword=${simpleState}`;
    const res = await axios.get(
      `${store.getters["getBaseUrl"]}/chosei/download-excel?${searchParams}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
        responseType: "arraybuffer",
        responseEncoding: "binary",
      },
    );
    if (res.data === "") {
      isDownLoading.value = false;
      notyf.error("ダウンロードするデータがありません");
    } else {
      downloadFile(res);
    }
  } catch (error) {
    isDownLoading.value = false;
    notyf.error("ダウンロードに失敗しました");
    console.log(error);
  }
};
const downloadFile = (resData: any) => {
  let blob = new Blob([resData.data], {
    type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  });
  let link = document.createElement("a");
  link.href = window.URL.createObjectURL(blob);
  link.download = `調整明細.xlsx`;
  link.click();
  isDownLoading.value = false;
};

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["OrderAdjustment", {
      Show_KaniSearch: _unref(isActive_KaniFlg),
      Show_SyosaiSearch: _unref(isActive_SyosaiFlg),
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createVNode(PankuzuHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      currentPathList: currentPathList
    }, null, 8, ["isActive_SidebarFlg"]),
    _createVNode(OrderHeader, {
      isActive_SidebarFlg: props.isActive_SidebarFlg,
      searchAreaToggle: _unref(searchAreaToggle),
      onChangeKaniFlg: changeKaniFlg,
      onChangeSyosaiFlg: changeSyosaiFlg,
      onOnSearch: onClickSearch,
      onChangeToggleArea: changeToggleArea,
      choseiInputExecutableFlg: choseiInputExecutableFlg.value
    }, null, 8, ["isActive_SidebarFlg", "searchAreaToggle", "choseiInputExecutableFlg"]),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_unref(Paginate), {
          "page-count": numberOfTotalPage.value,
          "hide-prev-next": true,
          "page-range": 3,
          "prev-text": '<',
          "next-text": '>',
          "container-class": 'pagination',
          "page-class": 'page-item',
          "page-link-class": 'page-item--link',
          "active-class": 'page-item--active',
          "click-handler": onClickPage,
          "force-page": currentPage.value
        }, null, 8, ["page-count", "force-page"]),
        _withDirectives(_createElementVNode("span", { class: "paging_result" }, " 検索結果：" + _toDisplayString(_unref(numberOfTotalData)) + "件/" + _toDisplayString(_unref(firstCount)) + "～" + _toDisplayString(_unref(finalCount)) + "件を表示", 513), [
          [_vShow, search_result.value.length]
        ])
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("button", {
          class: _normalizeClass(["OrderAdjustment_BtnGray", { ReturnSlip_BtnDisabled: _unref(isDownLoading) }]),
          download: "sample.txt",
          onClick: downloadChoseiData,
          disabled: _unref(isDownLoading)
        }, [
          (!_unref(isDownLoading))
            ? (_openBlock(), _createBlock(_component_font_awesome_icon, {
                key: 0,
                icon: "download",
                style: {"display":"inline-block"}
              }))
            : _createCommentVNode("", true),
          (_unref(isDownLoading))
            ? (_openBlock(), _createElementBlock("span", _hoisted_5))
            : _createCommentVNode("", true),
          _hoisted_6
        ], 10, _hoisted_4)
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["OrderAdjustment_TableContainer", tableHeight()])
    }, [
      _createElementVNode("table", _hoisted_7, [
        _createElementVNode("thead", null, [
          _createElementVNode("tr", null, [
            _hoisted_8,
            _createElementVNode("th", _hoisted_9, [
              _createElementVNode("span", {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (sortTable('syosiCd')))
              }, _toDisplayString(showSortSymbol("syosiCd")) + " 書誌CD", 1),
              _hoisted_10,
              _createElementVNode("span", {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (sortTable('janCd')))
              }, _toDisplayString(showSortSymbol("janCd")) + "ISBN13桁", 1)
            ]),
            _createElementVNode("th", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (sortTable('title'))),
              class: "OrderAdjustment_Table_Syosi OrderAdjustment_Table_Sticky_TH3 th_sort"
            }, _toDisplayString(showSortSymbol("title")) + "書誌名 ", 1),
            _createElementVNode("th", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (sortTable('author1'))),
              class: "OrderAdjustment_Table_Medium th_sort"
            }, _toDisplayString(showSortSymbol("author1")) + "著者 ", 1),
            _createElementVNode("th", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (sortTable('availableAmountBeforeAdjustment'))),
              class: "OrderAdjustment_Table_Medium th_sort"
            }, [
              _createTextVNode(_toDisplayString(showSortSymbol("availableAmountBeforeAdjustment")) + "調整前", 1),
              _hoisted_11,
              _createTextVNode("使用可能数 ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (sortTable('juchuSuu'))),
              class: "th_sort"
            }, _toDisplayString(showSortSymbol("juchuSuu")) + "受注数 ", 1),
            _createElementVNode("th", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (
                sortTable('subtractJuchuSuuFromAvailableAmountBeforeAdjustment')
              )),
              class: "OrderAdjustment_Table_Syosi th_sort"
            }, [
              _createTextVNode(_toDisplayString(showSortSymbol(
                  "subtractJuchuSuuFromAvailableAmountBeforeAdjustment",
                )) + "調整前使用可能数", 1),
              _hoisted_12,
              _createTextVNode("－受注数 ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (sortTable('choseiTotal'))),
              class: "th_sort"
            }, _toDisplayString(showSortSymbol("choseiTotal")) + "調整対象数 ", 1),
            _createElementVNode("th", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (sortTable('availableAmountAfterAdjustment'))),
              class: "OrderAdjustment_Table_Medium th_sort"
            }, [
              _createTextVNode(_toDisplayString(showSortSymbol("availableAmountAfterAdjustment")) + "調整後", 1),
              _hoisted_13,
              _createTextVNode("使用可能数 ")
            ]),
            _createElementVNode("th", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (sortTable('zaikoStatus'))),
              class: "OrderAdjustment_Table_Medium th_sort"
            }, _toDisplayString(showSortSymbol("zaikoStatus")) + "在庫ステータス ", 1),
            _createElementVNode("th", {
              onClick: _cache[10] || (_cache[10] = ($event: any) => (sortTable('category'))),
              class: "OrderAdjustment_Table_Medium th_sort"
            }, _toDisplayString(showSortSymbol("category")) + "カテゴリ ", 1),
            _createElementVNode("th", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (sortTable('username'))),
              class: "th_sort"
            }, _toDisplayString(showSortSymbol("username")) + "確定担当 ", 1)
          ])
        ]),
        (search_result.value.length)
          ? (_openBlock(), _createElementBlock("tbody", _hoisted_14, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(search_result.value, (item, index) => {
                return (_openBlock(), _createElementBlock("tr", { key: index }, [
                  _createElementVNode("td", _hoisted_15, [
                    _createElementVNode("button", {
                      onClick: ($event: any) => (toAdjustmentDetail(item.janCd)),
                      class: "OrderAdjustment_Table_Button"
                    }, [
                      _createVNode(_component_font_awesome_icon, {
                        class: "OrderAdjustment_Table_Icon",
                        icon: "play"
                      }),
                      _createTextVNode("詳細 ")
                    ], 8, _hoisted_16)
                  ]),
                  _createElementVNode("td", _hoisted_17, [
                    _createTextVNode(_toDisplayString(item.syosiCd), 1),
                    _hoisted_18,
                    _createTextVNode(_toDisplayString(item.janCd), 1)
                  ]),
                  _createElementVNode("td", _hoisted_19, _toDisplayString(item.title), 1),
                  _createElementVNode("td", null, [
                    _createTextVNode(_toDisplayString(item.author1), 1),
                    _hoisted_20,
                    _createTextVNode(" " + _toDisplayString(item.author2), 1),
                    _hoisted_21,
                    _createTextVNode(" " + _toDisplayString(item.author3), 1)
                  ]),
                  _createElementVNode("td", null, _toDisplayString(item.availableAmountBeforeAdjustment), 1),
                  _createElementVNode("td", null, _toDisplayString(item.juchuSuu), 1),
                  _createElementVNode("td", null, _toDisplayString(item.subtractJuchuSuuFromAvailableAmountBeforeAdjustment), 1),
                  _createElementVNode("td", null, _toDisplayString(item.choseiTotal), 1),
                  _createElementVNode("td", null, _toDisplayString(item.availableAmountAfterAdjustment), 1),
                  _createElementVNode("td", null, _toDisplayString(item.zsName), 1),
                  _createElementVNode("td", null, _toDisplayString(item.category), 1),
                  _createElementVNode("td", null, _toDisplayString(item.username), 1)
                ]))
              }), 128))
            ]))
          : _createCommentVNode("", true)
      ]),
      (!search_result.value.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_22, " ※検索結果はありません "))
        : _createCommentVNode("", true)
    ], 2)
  ], 2))
}
}

})